import packages from '../../Actions/packages';
const { types } = packages;

const initialState = {
    packagesData: [],
};

const packagesReducer = (state = initialState, action) => {
    switch (action.type) {        
        case types.SET_PACKAGES_DATA:
            return {
                ...state,
                packagesData: action.data
            }
        default:
            return state;
    }
}

export default packagesReducer;